import MaterialAdd from "./MaterialAdd";
import MaterialInfo from "./MaterialInfo";
import { SettingsContext } from "../context";
import { useContext } from "react";

function Materials() {
  const {
updateSceneMaterials,
}=useContext(SettingsContext);
const modelViewer=document.getElementById("modelViewer");

 
 

 



  const handleOnAddMaterial = (e) => {
    const modelViewer = document.getElementById("modelViewer");
    modelViewer.addEventListener(
      "init-model-load",
      updateSceneMaterials.bind(this)
    );
  };

  return (
    <div>
      <div>
        <MaterialInfo />
      </div>
      <MaterialAdd onAddMaterial={handleOnAddMaterial} />
    </div>
  );
}
export default Materials;
